import Axios from '../config/Axios';
import loadBreadcrumb from './ActionBreadcrumb';

export function getVersionHistory(nDocumentId) {
  return Axios.get(`/document/version-history/${nDocumentId}`).then(
    (oResponse) =>
      new Promise((resolve, reject) => {
        loadBreadcrumb(oResponse.data.oDocument.fldr_nid)
          .then((aBreadcrumbFolders) => {
            resolve({
              ...oResponse.data,
              "oDocument": oResponse.data.oDocument,
              aBreadcrumbFolders
            });
          })
          .catch((oError) => reject(oError));
      })
  );
}

export function unfile(nDocId, nRestoringFolderId) {
  return Axios.put(`/unfile/${nDocId}`, {
    nRestoringFolderId
  });
}
